import React from 'react';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      <div className="flex items-center justify-center mb-6">
        <img
          src="/assets/images/wilcart_logo_1-1775846328647.png"
          alt="Wilcart CRM Logo"
          className="h-14 w-auto object-contain"
        />
        <span className="ml-3 text-2xl font-bold text-foreground">Wilcart</span>
      </div>
      <div className="space-y-2">
        <h2 className="text-xl font-semibold text-foreground">Welcome back</h2>
        <p className="text-muted-foreground">
          Sign in to your Wilcart workspace to manage your sales pipeline and customer relationships
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;